import { US_MAP_CENTER } from "@/lib/maps/map-defaults";

export const US_CENTER = US_MAP_CENTER;
export const EMPTY_STATE_ZOOM = 5;
export const LOCATION_DEFAULT_ZOOM = 9;
export const POPULATED_ZOOM = 9;
export const CLUSTER_MAX_ZOOM = 14;
export const MIN_ZOOM = 3;
export const MAX_ZOOM = 15;

const RADIUS_TO_ZOOM: [number, number][] = [
  [25, 10],
  [50, 9],
  [100, 8],
  [200, 7],
  [500, 6],
];

export function getZoomForRadius(radiusMiles: number): number {
  for (const [radius, zoom] of RADIUS_TO_ZOOM) {
    if (radiusMiles <= radius) return zoom;
  }
  return 5;
}

function getZoomForListingRadius(distanceMiles: number): number {
  if (distanceMiles <= 10) return 11;
  if (distanceMiles <= 25) return 10;
  if (distanceMiles <= 50) return 9;
  if (distanceMiles <= 100) return 8;
  if (distanceMiles <= 200) return 7;
  return 6;
}

export function calculateOptimalZoom(
  products: Array<{ distance?: number }>,
  radiusMiles: number,
): number {
  const productsWithDistance = products.filter(
    (product): product is { distance: number } => typeof product.distance === "number",
  );

  if (productsWithDistance.length === 0) {
    return getZoomForRadius(radiusMiles);
  }

  const sortedByDistance = productsWithDistance.slice().sort(
    (left, right) => right.distance - left.distance,
  );
  const farthestDistance = sortedByDistance[0].distance;
  const medianIndex = Math.floor(productsWithDistance.length / 2);
  const medianDistance = sortedByDistance[medianIndex].distance;

  if (medianDistance < 30 && productsWithDistance.length >= 5) {
    const p80Index = Math.floor(productsWithDistance.length * 0.8);
    const p80Distance = sortedByDistance[p80Index]?.distance ?? medianDistance;
    return getZoomForListingRadius(p80Distance);
  }

  return getZoomForListingRadius(farthestDistance * 1.1);
}
